import React from "react"

const MailingList = () => {
  return (
    <div className="gradient">
      {/* <!-- Change the colour #f8fafc to match the previous section colour --> */}
      <svg
        class="wave-top"
        viewBox="0 0 1439 147"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
            <g class="wave" fill="#FFFFFF">
              <path d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"></path>
            </g>
            <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
              <g transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) ">
                <path
                  d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                  opacity="0.200000003"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      {/* ***************************************************** */}

      <div
        id="access"
        className="px-4 py-16 overflow-hidden sm:px-6 lg:px-8 lg:pb-20 xl:pt-2 xl:pb-20"
      >
        <div className="relative max-w-xl mx-auto">
          <div className="text-center">
            <h2 className="text-4xl font-extrabold leading-9 tracking-tight text-white font-title lg:text-5xl sm:leading-10">
              Get Early Access
            </h2>
            <p className="mt-6 text-lg leading-6 text-gray-50">
              Podwii is currently being deployed as a private release. Request
              early access and save your spot on our private list.
            </p>
          </div>
          <div className="mt-12">
            <form
              name="contact-bottom"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
              className="grid grid-cols-1 row-gap-6 sm:grid-cols-2 sm:col-gap-8"
            >
              <div className="sm:col-span-2">
                <div className="relative mt-1 rounded-md shadow-sm">
                  <p class="hidden">
                    <label>
                      Don’t fill this out if you're human:{" "}
                      <input name="bot-field" />
                    </label>
                  </p>
                  <input
                    type="hidden"
                    name="form-name"
                    value="contact-bottom"
                  />
                  <input
                    id="email-bottom"
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="block w-full px-4 py-3 transition duration-150 ease-in-out form-input"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <span className="inline-flex w-full rounded-md shadow-sm">
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-purple-600 border border-transparent rounded-md hover:bg-purple-500 focus:outline-none focus:border-purple-700 focus:shadow-outline-purple active:bg-purple-700"
                  >
                    Request Access
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ***************************************************** */}
    </div>
  )
}

export default MailingList
